/* ============================================================
   VANDA'S KITCHEN — CONNECTED CATERING JS
   ------------------------------------------------------------
   FILE: assets/vk-connected-catering.js
   INSTALL: Shopify Admin → Online Store → Themes → Edit code
            → Assets → Add a new asset → name it
            "vk-connected-catering.js" → paste this whole file.
   ------------------------------------------------------------
   Then add to theme.liquid before </body>:
   {{ 'vk-connected-catering.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  var API = 'https://api.vandaskitchen.co.uk';

  /* ---------------------------------------------------------
     UTIL
  --------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  function formatGBP(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  /* ---------------------------------------------------------
     1. CONNECTION SUCCESS BANNER
     When the OAuth flow redirects back with ?connected=google
     etc., show a confirmation message.
  --------------------------------------------------------- */
  function handleConnectionRedirect() {
    var connected = getQueryParam('connected');
    var failed = getQueryParam('connect_failed');
    var box = $('#vk-connect-success');
    if (!box) return;

    if (connected) {
      var names = { microsoft: 'Microsoft 365', google: 'Google Workspace', slack: 'Slack' };
      var label = names[connected] || connected;
      box.hidden = false;
      box.querySelector('p').textContent =
        label + ' connected. Your catering calculator can now pull your real headcount.';
      box.className = 'vk-connect-success vk-connect-success--ok';
    } else if (failed) {
      box.hidden = false;
      box.querySelector('p').textContent =
        'That connection did not complete. Please try again, or use manual headcount entry below.';
      box.className = 'vk-connect-success vk-connect-success--error';
    }
  }

  /* ---------------------------------------------------------
     2. CONNECTION STATUS
     Ask the backend which providers this customer has linked,
     and update the connect cards accordingly.
  --------------------------------------------------------- */
  function loadConnectionStatus() {
    var statusEl = $('#vk-connect-status');
    if (!statusEl) return;

    var customerId = statusEl.getAttribute('data-customer-id');
    if (!customerId) return;

    fetch(API + '/api/dashboard?shopify_customer_id=' + encodeURIComponent(customerId))
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var connections = (data && data.connections) || [];
        var activeProviders = connections
          .filter(function (c) { return c.status === 'active'; })
          .map(function (c) { return c.provider; });

        if (activeProviders.length > 0) {
          statusEl.querySelector('p').textContent =
            'Connected: ' + activeProviders.map(providerLabel).join(', ') +
            '. You can connect more or re-connect below.';
          statusEl.className = 'vk-connect-status vk-connect-status--connected';
        } else {
          statusEl.querySelector('p').textContent =
            'No calendars connected yet. Pick one below to get started.';
          statusEl.className = 'vk-connect-status';
        }

        // Update individual cards
        $all('.vk-connect-card').forEach(function (card) {
          var provider = card.getAttribute('data-provider');
          var actionLabel = card.querySelector('[data-action-label]');
          if (activeProviders.indexOf(provider) !== -1) {
            card.classList.add('vk-connect-card--connected');
            if (actionLabel) actionLabel.textContent = 'Connected · Re-connect';
          }
        });
      })
      .catch(function () {
        // Backend unreachable or customer not yet in system — leave default state
        statusEl.querySelector('p').textContent =
          'Pick a calendar below to connect.';
        statusEl.className = 'vk-connect-status';
      });
  }

  function providerLabel(p) {
    var names = {
      microsoft: 'Microsoft 365',
      google: 'Google Workspace',
      slack: 'Slack',
      direct_api: 'Direct API',
      manual: 'Manual'
    };
    return names[p] || p;
  }

  /* ---------------------------------------------------------
     3. CALCULATOR
  --------------------------------------------------------- */
  function initCalculator() {
    var calc = $('#vk-calc');
    if (!calc) return;

    var customerId = calc.getAttribute('data-customer-id');

    var dateEl = $('#vk-calc-date');
    var headcountEl = $('#vk-calc-headcount');
    var occasionEl = $('#vk-calc-occasion');
    var postcodeEl = $('#vk-calc-postcode');
    var autofillBtn = $('#vk-calc-autofill');
    var headcountHint = $('#vk-calc-headcount-hint');

    // Default the date to next weekday
    if (dateEl && !dateEl.value) {
      var d = new Date();
      d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() + 1);
      }
      dateEl.value = d.toISOString().split('T')[0];
    }

    // --- Pricing model (estimate only) ---
    // Per-head estimate in pence. Final price confirmed at order.
    var PER_HEAD_PENCE = 1150;

    function recalculate() {
      var headcount = parseInt(headcountEl.value, 10) || 0;
      var occasionText = occasionEl.options[occasionEl.selectedIndex].text;

      $('#vk-sum-headcount').textContent = headcount;
      $('#vk-sum-occasion').textContent = occasionText;
      $('#vk-sum-date').textContent = dateEl.value
        ? new Date(dateEl.value + 'T00:00:00').toLocaleDateString('en-GB',
            { weekday: 'short', day: 'numeric', month: 'short' })
        : '—';

      // Suggested items — simple heuristic
      var items = $('#vk-sum-items');
      items.innerHTML = '';
      if (headcount > 0) {
        var sandwichPlatters = Math.ceil(headcount * 1.5 / 12);
        var saladBowls = Math.ceil(headcount * 0.4 / 8);
        var sweets = Math.ceil(headcount * 0.5 / 10);
        var fruit = Math.max(1, Math.ceil(headcount / 30));
        addItem(items, sandwichPlatters + ' × sandwich platter');
        addItem(items, saladBowls + ' × salad bowl');
        addItem(items, sweets + ' × sweet treats platter');
        addItem(items, fruit + ' × fresh fruit platter');
      } else {
        addItem(items, 'Adjust the headcount to see suggestions');
      }

      // Total
      var totalPence = headcount * PER_HEAD_PENCE;
      $('#vk-sum-total').textContent = formatGBP(totalPence);
    }

    function addItem(ul, text) {
      var li = document.createElement('li');
      li.textContent = text;
      ul.appendChild(li);
    }

    // --- Auto-fill from calendar ---
    if (autofillBtn && customerId) {
      autofillBtn.addEventListener('click', function () {
        var date = dateEl.value;
        if (!date) {
          headcountHint.textContent = 'Pick a delivery date first.';
          return;
        }

        autofillBtn.disabled = true;
        autofillBtn.textContent = 'Checking your calendar…';
        headcountHint.textContent = '';

        fetch(API + '/api/headcount?shopify_customer_id=' +
              encodeURIComponent(customerId) + '&date=' + encodeURIComponent(date))
          .then(function (res) {
            if (res.status === 404) {
              throw new Error('no_connection');
            }
            if (!res.ok) {
              throw new Error('status ' + res.status);
            }
            return res.json();
          })
          .then(function (data) {
            headcountEl.value = data.headcount;
            var src = providerLabel(data.source);
            headcountHint.textContent =
              'Filled from ' + src + ' — ' + data.raw_attendance +
              ' attending' + (data.buffer_applied ? ' (plus a small buffer)' : '') + '.';
            // If the backend suggested a dietary breakdown, apply it
            if (data.suggested_dietary) {
              applyDietary(data.suggested_dietary);
            }
            recalculate();
          })
          .catch(function (err) {
            if (err.message === 'no_connection') {
              headcountHint.textContent =
                'No calendar connected yet. Connect one above, or just type the headcount in.';
            } else {
              headcountHint.textContent =
                'Could not reach your calendar just now. Please enter the headcount manually.';
            }
          })
          .then(function () {
            autofillBtn.disabled = false;
            autofillBtn.textContent = 'Auto-fill from my calendar';
          });
      });
    }

    function applyDietary(breakdown) {
      var map = {
        halal: '#vk-diet-halal',
        vegan: '#vk-diet-vegan',
        vegetarian: '#vk-diet-vegetarian',
        gluten_free: '#vk-diet-gluten_free',
        dairy_free: '#vk-diet-dairy_free'
      };
      Object.keys(map).forEach(function (key) {
        var el = $(map[key]);
        if (el && typeof breakdown[key] === 'number') {
          el.value = breakdown[key];
        }
      });
    }

    // --- Postcode check (light client-side hint only) ---
    if (postcodeEl) {
      postcodeEl.addEventListener('blur', function () {
        var pc = postcodeEl.value.trim().toUpperCase();
        var hint = $('#vk-calc-postcode-hint');
        if (!pc) { hint.textContent = ''; return; }
        // Central London outcodes we cover — light hint, real validation at checkout
        var covered = ['EC', 'WC', 'E1', 'SE1', 'N1', 'SW1', 'W1', 'E14', 'NW1'];
        var matches = covered.some(function (oc) { return pc.indexOf(oc) === 0; });
        hint.textContent = matches
          ? 'Looks like we deliver to your area. Exact availability confirmed at checkout.'
          : 'We may still deliver — exact availability is confirmed at checkout, or email us.';
      });
    }

    // --- Bind recalculation ---
    [dateEl, headcountEl, occasionEl].forEach(function (el) {
      if (el) {
        el.addEventListener('change', recalculate);
        el.addEventListener('input', recalculate);
      }
    });

    recalculate();
  }

  /* ---------------------------------------------------------
     INIT
  --------------------------------------------------------- */
  function init() {
    handleConnectionRedirect();
    loadConnectionStatus();
    initCalculator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();